export const loadFromGleapCache = (key: string) => {
    try {
        const cachedData = localStorage.getItem(key);
        if (cachedData) {
            const config = JSON.parse(cachedData);
            return config;
        }
    } catch (exp) { }
    return null;
};

export const saveToGleapCache = (key: string, data: any) => {
    if (data) {
        try {
            localStorage.setItem(key, JSON.stringify(data));
        } catch (exp) { }
    } else {
        localStorage.removeItem(key);
    }
};

// Every localStorage key the messenger owns starts with one of these prefixes.
// The messenger iframe is bootstrapped SAME-ORIGIN with the host page (the SDK
// creates it as about:blank + doc.write to dodge Safari ITP), so the iframe's
// localStorage IS the host app's localStorage. Clearing MUST be scoped to
// Gleap-owned keys — never localStorage.clear(), which would wipe the host
// app's own data (e.g. its auth tokens) and log the user out.
export const GLEAP_OWNED_KEY_PREFIXES = [
    "gleap-chatbar-active-ticket:",
    "formitem-",
    // Capture requests' per-device id (Stores/Capture getCaptureDeviceId).
    "gleap-capture-",
];

export const clearGleapCache = () => {
    try {
        const keysToRemove: string[] = [];
        // Collect first, then remove: removing during iteration shifts indices.
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (
                key &&
                GLEAP_OWNED_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))
            ) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach((key) => localStorage.removeItem(key));
    } catch (exp) { }
};
